import React from "react";
import Tips from "../Partial/Tips";
import CompleteVerification from "../Partial/CompleteVerification";
import { IMAGE_TYPES } from "~/constants/imageTypes";

interface DriverLicenceInstructionsProps {
  frontSrc: string;
  backSrc: string;
  selfieSrc: string;
  startCapture: any;
  back: () => void;
  complete: () => void;
}

const DriverLicenceInstructions = ({ frontSrc, backSrc, selfieSrc, startCapture, back, complete }: DriverLicenceInstructionsProps) => {

  /********** OTHER **********/

  const isFrontInfo = !frontSrc;
  const isBackInfo = frontSrc && !backSrc;
  const isSelfieInfo = frontSrc && backSrc;
  const isDLComplete = frontSrc && backSrc && selfieSrc;

  return <React.Fragment>
    {isDLComplete ?
      <CompleteVerification
        imageType={IMAGE_TYPES.DL_FRONT}
        frontSrc={frontSrc}
        backSrc={backSrc}
        selfieSrc={selfieSrc}
        startCapture={startCapture}
        complete={complete}
      /> :
      <Tips
        isFrontInfo={isFrontInfo}
        isBackInfo={isBackInfo}
        isSelfieInfo={isSelfieInfo}
        startCapture={startCapture}
        back={back}
      />}
  </React.Fragment>
}

export default DriverLicenceInstructions;